<template>
  <div class="">
        <div class="loading"></div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components:{},
  computed:{},
  methods:{},
  mounted:function(){}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    @zrGreen:#02cd8c;
    .loading{
        position:fixed;
        width:100%;
        height:100%;
        top:0;
        bottom:0;
        left:0;
        right:0;
        margin:auto;
        background:url(../../../static/img/loading.gif) 50% no-repeat;
        background-color:#fff;
        z-index:200;
    }

</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue